import type { CSSProperties } from 'react';
import { styled, css, type CSSProp } from 'styled-components';

import { SUBSECTION_DATA_ATTR } from './constants.ts';

interface SectionWrapper {
  height: CSSProperties['height'] | undefined;
  $inner: boolean | undefined;
}

export const SectionWrapper = styled.div<SectionWrapper>`
  background: ${({ theme }) => theme.colors.grey00_1};
  overflow: hidden;
  position: relative;
  border-radius: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;

  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `};

  ${({ theme, $inner }) =>
    $inner
      ? css`
          border: 1px solid ${theme.colors.grey10_1};
        `
      : theme.shadows.small}
`;

interface ItemsWrapperProps {
  $hasTitle: boolean | undefined;
  $isExpanded: boolean;
  $hasFixedHeight: boolean;
  $customStyles: CSSProp | undefined;
}

export const ItemsWrapper = styled.div<ItemsWrapperProps>`
  display: flex;
  flex-direction: column;
  flex: ${({ $hasFixedHeight }) => ($hasFixedHeight ? '1' : '0 1 auto')};
  min-height: 0;
  overflow-y: ${({ $isExpanded }) => ($isExpanded ? 'auto' : 'hidden')};

  ${({ theme, $hasTitle }) =>
    $hasTitle &&
    css`
      border-top: 1px solid ${theme.colors.grey10_1};
    `}

  & > [${SUBSECTION_DATA_ATTR}] + [${SUBSECTION_DATA_ATTR}] {
    border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
  }

  ${({ $customStyles }) => $customStyles}
`;
